import { Input, InputGroup, InputProps, InputRightElement } from '@chakra-ui/react';
import { FormikTouched } from 'formik';
import { ChangeEvent } from 'react';
import { ILoginInfo } from '@/components/LoginForm';

export type LoginInputProps = {
  name: string;
  touched: FormikTouched<ILoginInfo>;
  id: 'username' | 'password';
  rightIcon?: JSX.Element;
  isPassword?: boolean;
  onIconClick?: () => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  formatFn?: (value: string) => string;
  inputProps?: InputProps; 
} & InputProps;

export default function LoginInput2({
  name,
  setFieldValue,
  formatFn,
  touched,
  id,
  rightIcon,
  onIconClick,
  isPassword = false,
  inputProps,
  ...props
}: LoginInputProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    if (formatFn) {
      inputValue = formatFn(inputValue);
    }
    setFieldValue(name, inputValue);
  };

  return (
    <InputGroup>
      <Input
        type={props.type}
        bgColor='transparent'
        color='white'
        fontFamily='Lexend Deca'
        fontWeight='400'
        onChange={handleChange}
        value={props.value}
        _placeholder={{ color: 'white', fontSize: props.fontSize }}
        {...inputProps} 
        {...props}
      />
      {isPassword && (
        <InputRightElement onClick={onIconClick} cursor='pointer'>
          {rightIcon}
        </InputRightElement>
      )}
    </InputGroup>
  );
}
